import { useAuth } from '@shared/common/providers/AuthProvider';

import { useRoundTickets } from '../../../../model/web3Raffle/api/useRoundTickets';
import { ViewMyTicketsButton } from '../../../modals/ViewMyTicketsButton/ViewMyTicketsButton';
import { GetTicketsButton } from './GetTicketsButton/GetTicketsButton';

type Props = {
  roundId?: bigint;
};

export const CardButtons = ({ roundId }: Props) => {
  const { userEvmWallet, isLoading: isAuthLoading } = useAuth();

  const { data: myTickets, isLoading: isRoundTicketsLoading } = useRoundTickets(
    roundId,
    userEvmWallet?.attributes?.address,
  );

  const isLoading = isAuthLoading || !roundId || isRoundTicketsLoading;
  const showViewMyTicketsButton = !isLoading && !!myTickets?.boughtTicketsCount && !!roundId;

  return (
    <div className="flex gap-2">
      {showViewMyTicketsButton && <ViewMyTicketsButton roundId={roundId} />}
      <GetTicketsButton isLoading={isLoading} />
    </div>
  );
};
